import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

//hooks
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

//components
import AnalyticsGrid from '@/components/layouts/wrappers/AnalyticsGrid';
import ErrorAnalyticsFallback from '@/components/layouts/ErrorFallbacks/ErrorAnalyticsFallback';

export const AnalyticsWrapper = ({
    periodStart,
    periodEnd,
    period,
    compareTo,
    albumId,
    album,
    children,
    className
}) => {
    const { activeSocialProfile } = useActiveSocialProfile();

    return (
        <ErrorBoundary FallbackComponent={ErrorAnalyticsFallback}>
            <AnalyticsGrid className={className}>
                {React.Children.map(children, (child) =>
                    React.cloneElement(child, {
                        activeSocialProfile,
                        periodStart,
                        periodEnd,
                        period,
                        compareTo,
                        albumId,
                        album
                    })
                )}
            </AnalyticsGrid>
        </ErrorBoundary>
    );
};
